<script setup>
import { formatMarketMetric } from 'src/utils/market-util';
import { computed } from 'vue';

const $props = defineProps({
    relative: {
        type: Boolean,
        default: false
    },
    rows: {
        type: Array,
        default: () => []
    }
});

const largestValue = computed(() => Math.max(0, ...$props.rows.map(row => row.value ?? 0)));

function barValue(row) {
    if ($props.relative) {
        return largestValue.value > 0 ? row.value / largestValue.value : 0;
    }
    return Math.min(Math.max((row.percent ?? 0) / 100, 0), 1);
}
</script>

<template>
    <ul class="market-share-list q-pl-none q-my-none">
        <li v-for="row in $props.rows" :key="row.label" class="q-py-md">
            <div class="row items-baseline justify-between no-wrap q-gutter-x-md">
                <a v-if="row.href" :href="row.href" class="text-body1 text-weight-medium">{{ row.label }}</a>
                <span v-else class="text-body1 text-weight-medium">{{ row.label }}</span>
                <span class="font-mono text-body2 text-no-wrap">
                    <strong v-if="!$props.relative">{{ formatMarketMetric(row.percent, { type: 'percentage' }) }}</strong>
                    <span v-if="row.detail" class="text-hint q-ml-sm">{{ row.detail }}</span>
                </span>
            </div>
            <q-linear-progress :value="barValue(row)" class="market-meter q-mt-xs" color="primary" size="8px"/>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
.market-share-list {
    list-style: none;
}
</style>
